import { mapValues } from 'lodash';
import { type CallbackOrSelectorProps, bridgeSelectorAndCallback } from '../../utils';
import {
  _internal_layoutVersionAtom,
  analysisViewTypeState,
  blockInfoGraphicType,
  blockSettings,
  studioPrintOrientationType,
  viewDataGridSizeType,
} from '../configuration';
import type { BlockId } from '../types';
import { allBlockFontsState, blockTableSpacingRatioState } from './blockFonts';
import { oldBlockConfigToFontSizeMappers, mapOldConfigToTableSpacingRatio } from './oldConfigMappers';
import { assertNotNil } from 'venn-utils';

/** Sets custom font settings based on the current  */
export const recoilSyncFontsFromOldSettings = (recoilProps: CallbackOrSelectorProps) => (blockId: BlockId) => {
  const { customFonts, tableSpacingRatio } = recoilGetFontsFromOldSettings(recoilProps)(blockId);
  recoilProps.set(allBlockFontsState(blockId), customFonts);
  recoilProps.set(blockTableSpacingRatioState(blockId), tableSpacingRatio);
};

export const recoilGetFontsFromOldSettings = (recoilProps: CallbackOrSelectorProps) => (blockId: BlockId) => {
  const { get } = bridgeSelectorAndCallback(recoilProps);

  const analysisViewType = get(analysisViewTypeState);
  const layoutVersion = get(_internal_layoutVersionAtom);
  const dataGridSizeType = get(viewDataGridSizeType(blockId));

  const blockType = assertNotNil(get(blockSettings(blockId)).customBlockType);
  const infographicType = assertNotNil(get(blockInfoGraphicType(blockId)));
  const orientation = get(studioPrintOrientationType);

  return getFontsFromOldSettings({
    analysisViewType,
    layoutVersion,
    dataGridSizeType,
    blockType,
    infographicType,
    orientation,
  });
};

export function getFontsFromOldSettings(...props: Parameters<typeof mapOldConfigToTableSpacingRatio>) {
  return {
    customFonts: mapValues(oldBlockConfigToFontSizeMappers, (mapOldConfig) => ({
      fontSizePt: mapOldConfig(...props),
    })),
    tableSpacingRatio: mapOldConfigToTableSpacingRatio(...props),
  };
}
